const deduplicateFragments = (document) => {
  const seen = /* @__PURE__ */ new Set();
  return {
    ...document,
    definitions: document.definitions.filter((definition) => {
      if (definition.kind === "FragmentDefinition") {
        const fragmentName = definition.name.value;
        if (seen.has(fragmentName)) {
          return false;
        }
        seen.add(fragmentName);
      }
      return true;
    })
  };
};
export {
  deduplicateFragments
};
